var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V9.5",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0146 18.937C19.8445 18.937 20.5174 18.2959 20.5174 17.505C20.5174 16.7141 19.8445 16.073 19.0146 16.073C18.1846 16.073 17.5117 16.7141 17.5117 17.505C17.5117 18.2959 18.1846 18.937 19.0146 18.937Z",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.9188V17.0812C14 16.5859 14.4253 16.1806 14.9452 16.1806C15.8526 16.1806 16.2212 15.5681 15.7675 14.8206C15.5028 14.3883 15.6635 13.8299 16.1172 13.5868L16.9773 13.1094C17.3743 12.8843 17.8847 13.0194 18.121 13.3976L18.1777 13.4877C18.6314 14.2352 19.3686 14.2352 19.8223 13.4877L19.879 13.3976C20.1153 13.0194 20.6257 12.8933 21.0227 13.1094L21.8828 13.5868C22.3365 13.8389 22.4972 14.3883 22.2325 14.8206C21.7788 15.5681 22.1474 16.1806 23.0548 16.1806C23.5747 16.1806 24 16.5859 24 17.0812V17.9188C24 18.4141 23.5747 18.8194 23.0548 18.8194C22.1474 18.8194 21.7788 19.4319 22.2325 20.1794C22.4972 20.6117 22.3365 21.1701 21.8828 21.4132L21.0227 21.8906C20.6257 22.1157 20.1153 21.9806 19.879 21.6024L19.8223 21.5123C19.3686 20.7648 18.6314 20.7648 18.1777 21.5123L18.121 21.6024C17.8847 21.9806 17.3743 22.1067 16.9773 21.8906L16.1172 21.4132C15.6635 21.1611 15.5028 20.6117 15.7675 20.1794C16.2212 19.4319 15.8526 18.8194 14.9452 18.8194C14.4253 18.8284 14 18.4231 14 17.9188Z",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.75016fe1.svg";
export { ForwardRef as ReactComponent };